<template>
	<FormulateForm name="form" v-model="form" @submit="save">
		<div class="row row-xs mb-3">
			<div class="col-12 mb-3">
				<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />
			</div>
			<div class="col-12 mb-3">
				<FormulateInput label="Apellido" name="lastname" validation-name="Apellido" validation="required" />
			</div>
			<div class="col-12 mb-3">
				<FormulateInput label="Email" type="email" name="email" validation-name="Email" validation="required" />
			</div>
			<div class="col-12 mb-3">
				<FormulateInput
					label="Documento de identidad"
					type="identification"
					name="document"
					validation-name="Documento de identidad"
					validation="bail|required|documentID"
				/>
			</div>

			<div class="col-12 mb-3">
				<FormulateInput
					label="Teléfono"
					type="phone"
					name="phone"
					validation-name="Teléfono"
					validation="optional|^phone"
				/>
			</div>

			<div class="col-12">
				<div class="d-flex justify-content-end mt-4">
					<div class="btn btn-primary" @click="$formulate.submit('form')">
						<span v-if="saving">Guardando <span class="btn-loader" /> </span>
						<span v-else>Guardar cambios</span>
					</div>
				</div>
			</div>
		</div>
	</FormulateForm>
</template>

<script>
import gql from "graphql-tag"

import mixins from "@/mixins/mixins"

export default {
	name: "UserForm",
	mixins: [mixins],
	data() {
		return {
			loading: false,
			saving: false,
			form: {
				name: null,
				lastname: null,
				email: null,

				phone: null,
				document: {
					type: "UY",
					number: null
				}
			}
		}
	},
	async beforeMount() {
		this.loading = true

		await this.load()

		this.loading = false
	},
	methods: {
		save() {
			if (!this.saving) {
				this.saving = true
				let dataInput = {
					name: this.form.name,
					lastname: this.form.lastname,
					email: this.form.email,

					phone: this.form.phone,
					document: this.form.document
				}
				this.update(dataInput)
			}
		},

		update(dataInput) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: UserInput!) {
							userProfileUpdate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data: dataInput
					}
				})
				.then(() => {
					this.$toast.success("Cambios guardados correctamente")
					this.saving = false
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},

		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query {
							userLogged {
								id
								name
								lastname
								email
								phone {
									countryCode
									national
									international
									type
									validated
								}
								document {
									type
									number
								}
							}
						}
					`,
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					const dataUser = this.$omitDeep(data.userLogged, "__typename")
					this.form.name = dataUser.name
					this.form.lastname = dataUser.lastname
					this.form.email = dataUser.email

					this.form.phone = dataUser.phone
					this.form.document = dataUser.document || { type: "UY", number: null }
					this.loading = false
				})
				.catch((err) => {
					this.$toast.success("El item que desea editar no existe")
				})
		}
	}
}
</script>

<style scoped>
.row {
	margin: auto;
	max-width: 360px;
}
</style>
